export const MarketplaceGrid = {
  display: 'grid',
  padding: 'A',
  // Density-driven spacing: 'compact' yields a tighter 'Z' gap, any
  // other value (including the default 'comfortable' / undefined)
  // uses 'A'. Same shape on minmax() — 240px vs 320px min width.
  gap: (el) => {
    const host = el.call('marketplaceHostOf', el)
    return host?.gridDensity === 'compact' ? 'Z' : 'A'
  },
  gridTemplateColumns: (el) => {
    const host = el.call('marketplaceHostOf', el)
    const min = host?.gridDensity === 'compact' ? '240px' : '320px'
    return `repeat(auto-fill, minmax(${min}, 1fr))`
  },
  alignContent: 'start',

  // Kick off the live catalogue fetch + persisted-install hydration on
  // mount. The host is either the nearest `MarketplaceIsland` or the
  // app root (see `marketplaceHostOf` in functions/index.js) — this lets
  // canvas + landing embed the grid without polluting their app roots
  // with marketplace state. `hydrateLiveCatalog` merges
  // `integration_kinds` rows from governance into host.catalog;
  // `hydrateInstalledFromPrefs` restores the installed-items list from
  // sdk-bridge prefs so the "Installed" button state survives reloads.
  onCreate: (el) => {
    const host = el.call('marketplaceHostOf', el)
    if (!host) return
    el.call('hydrateLiveCatalog', host)
    el.call('hydrateInstalledFromPrefs', host)
    el.call('hydrateSortFromPrefs', host)
    el.call('hydrateRecentFromPrefs', host)
    el.call('hydrateDensityFromPrefs', host)
    el.call('hydratePinnedFromPrefs', host)
  },

  // Each visible child carries its own `extends` so the grid can render
  // two different templates in the same array: `MarketplaceCard`
  // (16:9 thumbnail hero) for library + template,
  // `MarketplaceIntegrationRow` (horizontal row with logo only) for
  // integration + registrar + plugin. Per-child extends is merged with
  // childExtends by the framework, so the catalog-driven choice wins.
  //
  // Filter lifted out of per-card `hide:` functions — `matchesFilters`
  // (functions/index.js) is the single source of truth. Grid filters
  // catalog → visible items here; cards + rows render only what passes.
  //
  // Empty-state: when the filter returns zero items, short-circuit to
  // a single `MarketplaceEmptyState` element. Named siblings inside the
  // grid don't work because `children: fn` fully owns rendering per
  // smbls/packages/element/src/create.js:1461-1463.
  children: (el) => {
    const host = el.call('marketplaceHostOf', el)
    const items = host?.catalog || []
    const visible = items.filter((item) => el.call('matchesFilters', item, host))
    if (visible.length === 0) return [{ extends: 'MarketplaceEmptyState' }]
    const sorted = el.call('sortItems', visible, host?.activeSort, host?.query)
    return sorted.map((item) => ({
      ...item,
      extends: item.kind === 'integration' || item.kind === 'plugin' || item.kind === 'registrar'
        ? 'MarketplaceIntegrationRow'
        : 'MarketplaceCard'
    }))
  }
}
